module.exports = __webpack_public_path__ + "img/features-diversion.d00d5fb0.svg";